import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import { ImageProps } from "@lib/image";

export interface StrapiVideoSectionDTO extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  video: StrapiMediaDTO;
  externalUrl: string;
  poster: StrapiMediaDTO;
}

export class VideoSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  video: ImageProps;
  externalUrl: string;
  poster: ImageProps;
}
